import { Component, OnDestroy, OnInit } from '@angular/core';
import { faClipboard, faGlobe } from '@fortawesome/pro-light-svg-icons';
import { AcModel } from 'projects/runner/src/app/models/ac.model';
import { CandidateModel } from 'projects/runner/src/app/models/candidate.model';
import { ObserverModel } from 'projects/runner/src/app/models/observer.model';
import { ReportModel } from 'projects/runner/src/app/models/report.model';
import { ApiService } from 'projects/runner/src/app/services/api.service';
import { AuthStateService } from 'projects/runner/src/app/services/auth-state.service';
import { DataService } from 'projects/runner/src/app/services/data.service';
import { TimezoneService } from 'projects/runner/src/app/services/timezone.service';
import { UiService } from 'projects/runner/src/app/services/ui.service';
import { catchError, interval, of, startWith, Subscription, switchMap } from 'rxjs';

const POLLING_INTERVAL = 5; // seconds

@Component({
  selector: 'app-participant-container',
  templateUrl: './participant-container.component.html',
  styleUrls: ['./participant-container.component.scss']
})
export class ParticipantContainerComponent implements OnInit, OnDestroy {

  public ac: AcModel = null;
  private acSubscription: Subscription = null;

  public faClipboard = faClipboard;
  public faGlobe = faGlobe;

  private reportPolling: Subscription = null;
  public resultReports: { [key: string]: ReportModel } = null;

  constructor(
    private data: DataService,
    private ui: UiService,
    private api: ApiService,
    public timezone: TimezoneService,
    public auth: AuthStateService
  ) { }

  ngOnInit(): void {
    this.acSubscription = this.data.ac$.subscribe({
      next: (ac: AcModel) => {
        if (ac !== null) {
          this.ac = ac;
          this.initPolling();
        }
      }
    });
  }

  ngOnDestroy(): void {
    if (this.acSubscription !== null) {
      this.acSubscription.unsubscribe();
      this.acSubscription = null;
    }
    if (this.reportPolling !== null) {
      this.reportPolling.unsubscribe();
      this.reportPolling = null;
    }
  }

  public copyDirectUrl(model: ObserverModel | CandidateModel): void {
    this.ui.copyToClipboard(model.directlink);
  }

  private initPolling(): void {
    if (this.reportPolling === null) {
      this.reportPolling = interval(POLLING_INTERVAL * 1000)
        .pipe(
          startWith(0),
          switchMap(() => {
            if (this.ac?.loaded && this.ac.isFinished() && this.shouldPoll()) {
              return this.api.getResultReport().pipe(
                catchError((e: any) => {
                  return of(null);
                })
              )
            } else {
              return of(null);
            }
          })
        )
        .subscribe({
          next: (result: any) => {
            if (result?.data) {
              this.resultReports = Object.entries(result.data).reduce((acc, [key, value]) => {
                acc[key] = new ReportModel().deserialize(value);
                return acc;
              }, {} as { [key: string]: ReportModel });
            }
          }
        });
    }
  }

  public onReportChanged(report: ReportModel, id: string): void {
    this.resultReports = { ...(this.resultReports || {}), [id]: report };
  }

  private shouldPoll(): boolean {
    return this.resultReports === null || Object.values(this.resultReports).some((report: ReportModel) => report.status === 'generating');
  }

}
